/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {  TGeocodedForSearchRequest,  TGeocodedForSearchModel,  IMappers,  TGeocodedForSearchResponse } from './types'
import type {  IHttpApi,  IHttpApiFetchConfig,  FetchResponse } from '@cian/http-api'
import type {  IPublicGeocodedForSearchV1Response } from '../../entities/Geocoding/PublicGeocodedForSearchV1Response'


export function createGeocodedForSearchModel(parameters: TGeocodedForSearchRequest): TGeocodedForSearchModel {
return {
v: 1,apiType: 'public',method: 'POST',microserviceName: 'geo',pathApi: '/v1/geocoded-for-search/',response: {
200: {
contentType: 'json',
},
},request: {
contentType: 'json',parameters,

},
};
}


export interface IGeocodedForSearchOptions<TResponse200>  {
httpApi: IHttpApi;
config?: IHttpApiFetchConfig;
mappers?: IMappers<TResponse200>;
parameters: TGeocodedForSearchRequest;

}

export async function fetchGeocodedForSearch<TResponse200>({
httpApi,
config,
mappers,
parameters,

}: IGeocodedForSearchOptions<TResponse200>): Promise<FetchResponse<TGeocodedForSearchResponse> | TResponse200> {
const {
statusCode,
response,
headers,

} = (await httpApi.fetch(createGeocodedForSearchModel(parameters), config)) as FetchResponse<TGeocodedForSearchResponse>;
if (mappers && statusCode in mappers) {
if (statusCode === 200) {
return mappers[200](response as IPublicGeocodedForSearchV1Response, headers);
}
}return {
statusCode,
response,
headers,

} as FetchResponse<TGeocodedForSearchResponse>;
}

